import React, { useState } from 'react';
import { ArticleConstants } from '../../adapters/helpers/Constants';
import { AssetProps } from '../../types';
import { handleGAEvents } from '../../adapters/helpers/Utils';

interface ListItem {
    fields: {
        anchorIdOfRespectedSection: string;
        contentType: string;
        listItemName: string;
        gaEventCategory?: string;
        gaEventAction?: string;
        gaEventLabel?: string;
    };
}

interface ArticleTableOfContentProps {
    tableOfContent?: {
        fields?: {
            className?: string;
            contentType?: string;
            id?: string;
            itemList?: ListItem[];
            listItemIcon?: {
                fields?: {
                    alternateText?: string;
                    asset?: AssetProps;
                };
            };
            openIcon?: {
                fields?: {
                    alternateText?: string;
                    asset?: AssetProps;
                };
            };
            closeIcon?: {
                fields?: {
                    alternateText?: string;
                    asset?: AssetProps;
                };
            };
            title?: string;
        };
    };
    isMobile?: boolean;
}

const handleScrollToSection = (
    anchorId: string,
    mobileOffset: number = 80,
    desktopOffset: number = 175
) => {
    const element = document.getElementById(anchorId);
    if (element) {
        const isMobile = window.innerWidth < 768;
        const offset = isMobile ? mobileOffset : desktopOffset;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth',
        });
    }
};

const ArticleTableOfContent: React.FC<ArticleTableOfContentProps> = ({ tableOfContent, isMobile }) => {
    const { title, itemList, listItemIcon, openIcon, closeIcon } = tableOfContent?.fields || {};
    const [isOpen, setIsOpen] = useState(false);

    const currentIcon = isOpen ? closeIcon : openIcon;
    const currentIconUrl = currentIcon?.fields?.asset?.fields?.file?.url;
    const currentIconAltText = currentIcon?.fields?.alternateText;

    const iconUrl = listItemIcon?.fields?.asset?.fields?.file?.url;
    const iconAltText = listItemIcon?.fields?.alternateText;

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className='article-table-content w-full p-1h bg-gradient-to-r from-revamp_blue_gradient to-revamp_darkBlue_gradient md:from-revamp_bg md:to-revamp_bg md:rounded-xl md:bg-revamp_bg'>
            <div className='flex items-center justify-center'>
                {title && (
                    <h2 className='font-semi-bold lg:font-bold text-xl md:text-2xl lg:text-25 text-white leading-1/2 pr-2 pl-4'>
                        {title}
                    </h2>
                )}
                {isMobile && currentIconUrl && (
                    <img
                        src={`https:${currentIconUrl}`}
                        alt={currentIconAltText || (isOpen ? ArticleConstants?.CloseIcon : ArticleConstants?.OpenIcon)}
                        width={20}
                        height={20}
                        onClick={toggleAccordion}
                        className='ml-1 cursor-pointer'
                    />
                )}
            </div>
            {(!isMobile || isOpen) && (
                <ul className='list-none pl-2 md:pl-1 lg:pl-2 pr-4 md:pr-0 pt-1 pb-0 lg:pr-3'>
                    {itemList?.map((item, index) => {

                    const gaEventCategory = item?.fields?.gaEventCategory || '';
                    const gaEventAction = item?.fields?.gaEventAction || '';
                    const gaEventLabel = item?.fields?.gaEventLabel || ''

                    return (
                        <li key={index} className='flex justify-start items-start py-1 px-0'>
                            {iconUrl && (
                                <img
                                    src={`https:${iconUrl}`}
                                    alt={iconAltText || ArticleConstants?.ListItemIcon}
                                    width={20}
                                    height={20}
                                    className='mt-[4px]'
                                />
                            )}
                            <button
                                onClick={() => {
                                    handleGAEvents(gaEventCategory, gaEventAction, gaEventLabel);
                                    handleScrollToSection(item?.fields?.anchorIdOfRespectedSection)
                                }}
                                className='article-table-contentLink w-full font-regular text-revamp_white text-lg text-left px-1 lg:pl-1/2h lg:pr-0 bg-transparent border-none cursor-pointer'
                            >
                                {item?.fields?.listItemName}
                            </button>
                        </li>
                    )})}
                </ul>
            )}
        </div>
    );
};

export default ArticleTableOfContent;